$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import {Navigation,Pagination,Autoplay,} from 'swiper/modules';




gsap.registerPlugin(ScrollTrigger);

jQuery(function ($) {


    // --- SHOWHIDE NAVBAR ---

    var didScroll;
    var lastScrollTop = 0;
    var delta = 120;
    var navbarHeight = 110;
    $(window).scroll(function () {
        didScroll = true;
    });
    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 350);
    function hasScrolled() {
        var st = $(this).scrollTop();
        if (Math.abs(lastScrollTop - st) <= delta)
            return;
        if (st > lastScrollTop && st > navbarHeight) {
            $('.nav-sticky').addClass('nav-up');
        } else {
            if (st + $(window).height() < $(document).height()) {
                $('.nav-sticky').removeClass('nav-up');
            }
        }
        lastScrollTop = st;
    }
    
    // --- NAV ---

    
    $(".nav-burger").click(function () {
        $(".burger").toggleClass("active");
        $(".nav-responsive").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    }); 
    
    $(".nav ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-active ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        } 
    });

    $(".nav-responsive ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-active ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        } 
    });
    
    $(".page-single article .gallery br").remove();  

    // --- BURGER ANIMATED ---
    
    $('#nav-burger-animated').click(function () {
        $(this).toggleClass('open');
    });

    // --- NOTICE ALERT ---
    
    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });
    
    $(document.body).trigger('wc_fragment_refresh');


     // --- ANNIMATION CIRCLE  ---


    gsap.to(".circular-bar", {
        "--p": '100%',
        duration: 6,
        ease: 'expo.out',
        scrollTrigger: {
            trigger: '.section__circle',
            start: 'top 60%', 
            end: 'bottom 60%', 
            scrub: true,
            //markers:true
        }
    });

   
    // --- SWIPER PRESTATION  ---

    var swiper = new Swiper(".mySwiper", {
        modules: [Pagination],
        pagination: {
          el: ".swiper-pagination",
        },
      });

      // --- SWIPER VISITE  ---

    var swiper = new Swiper(".Swiper_visite", {
        modules: [Pagination],
        pagination: {
          el: ".swiper-pagination",
        },
      });

      

       // === COUNT UP ===
    const countUpElements = document.querySelectorAll('.count-up');
    countUpElements.forEach(element => {
        const targetValue = parseInt(element.textContent, 10);
        element.textContent = '0';
        const counter = { value: 0 };
        ScrollTrigger.create({
            trigger: element,
            start: 'top 95%',
            onEnter: () => gsap.to(counter, {
                value: targetValue,
                duration: 1.5,
                onUpdate: () => {
                    element.textContent = Math.round(counter.value);
                },
                ease: "power1.inOut"
            }),
            //markers: true,
        });
    });



    // === ACCORDIONS ===
    const accordionItems = gsap.utils.toArray(".accordion-item");
    const accordionHeaders = gsap.utils.toArray(".accordion-header");
    const accordionAnimations = [];

    accordionItems.forEach(accordionItem => createAnimation(accordionItem));
    accordionHeaders.forEach(accordionHeader => {
        accordionHeader.addEventListener("click", () => toggleAnimation(accordionHeader));
    });

    function toggleAnimation(accordionHeader) {
        accordionHeaders.forEach(accordionHeader => {
            accordionHeader.classList.remove("active");
        });
        const selectedReversedState = accordionHeader.animation.reversed();
        accordionAnimations.forEach(accordionAnimation => accordionAnimation.reverse());
        accordionHeader.animation.reversed(!selectedReversedState);
        if (!accordionHeader.animation.reversed()) {
            accordionHeader.classList.add("active");
            updateImage(accordionHeader);
        } else {
            updateImage(null);
        }
    }

    function createAnimation(accordion) {
        const accordionHeader = accordion.querySelector(".accordion-header");
        const accordionContent  = accordion.querySelector(".accordion-content");

        gsap.set(accordionContent, { height: "270px"});
        const tween = gsap.from(accordionContent, {
            height: 0,
            duration: 0.5,
            ease: "power1.inOut",
            reversed: true
        });
        accordionHeader.animation = tween;
        accordionAnimations.push(tween);
    }

    function updateImage(accordionHeader) {
        // Cache toutes les images
        $(".prestation__container .col__img .img__container img").hide();

        if (accordionHeader) {
            // Récupère le data-id de l'item parent
            const id = $(accordionHeader).closest(".accordion-item").data("id");
            // Affiche l'image correspondante
            $(`#id-${id}`).show();
        } else {
            // Si aucun accordéon n'est actif, affiche l'image par défaut
            $("#id-1").show();
        }
    }

    // Affiche par défaut la première image
    $("#id-1").show();



     // --- FILTRE PAGE PROJET ---


     // Filtrage pour les boutons (tablette et ordinateur)
    $('.filter__btn').on('click', function() {
        $('.filter__btn').removeClass('active'); // Supprimer la classe "active" de tous les boutons de filtre
        $(this).addClass('active'); // Ajouter la classe "active" au bouton de filtre cliqué
        var cat = $(this).data('cat');
        if (cat === 'all') {
            $('.realisation_item').show();
        } else {
            $('.realisation_item').hide(); // Cacher tous les projets
            $('.realisation_item[data-cat*="' + cat + '"]').show(); // Afficher les projets qui ont le slug de catégorie dans leurs data-attribute
        }
    });

    // Filtrage pour le select (mobile)
    $('.filter__dropdown').on('change', function() {
        var cat = $(this).val();
        if (cat === 'all') {
            $('.realisation_item').show();
        } else {
            $('.realisation_item').hide(); // Cacher tous les projets
            $('.realisation_item[data-cat*="' + cat + '"]').show(); // Afficher les projets qui ont le slug de catégorie dans leurs data-attribute
        }
    });


    // --- ANIMATION 360° MESSAGE ---
    const textElement = $('svg .text');

    gsap.to(textElement, {
        duration: 10,     
        rotation: 360,    
        ease: 'linear',   
        repeat: -1,       
        transformOrigin: '50% 50%' 
      });
});

    
    

